var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CountDownPlugin',{attrs:{"count_to":_vm.destinationTime,"format":_vm.blok.format,"size":_vm.blok.size,"color":_vm.blok.color}})}
var staticRenderFns = []

export { render, staticRenderFns }